import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useStyles } from "./styles";
import Carousel, { consts } from "react-elastic-carousel";
import CloseIcon from "@mui/icons-material/Close";
import { DocumentViewer } from "../pdfviewer";
import NoDataFound from "../noDataFound/noDataFound";
import { generateImageUrl, img_size } from "../../utils";
import { VideoCard } from "../../screens/maintenance/videoCard";

const ImageAndPdfViewer = (props) => {
  const { assets, onClose, title } = props;
  const [data, setData] = React.useState({});
  const classes = useStyles();
  const breakPoints = [{ width: 1, itemsToShow: 1 }];

  const myArrow = ({ type, onClick, isEdge }) => {
    const pointer =
      type === consts.PREV ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />;
    return (
      <IconButton
        size="small"
        style={{ fontSize: "1.25rem" }}
        onClick={onClick}
        disabled={isEdge}
      >
        {pointer}
      </IconButton>
    );
  };
  const hasAssets = Array.isArray(assets) && assets.length > 0;
  React.useEffect(() => {
    if (!hasAssets) {
      if (assets) {
        const extension = assets.split(".").pop();
        setData({
          type: extension,
          file_url: assets,
        });
      }
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        p={1}
        className={classes.titleBar}
      >
        <Box flexGrow={1}>
          <Typography className={classes.detailTitle}>
            {title}
          </Typography>
        </Box>
        <Box>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon style={{ fontSize: "1.25rem" }} />
          </IconButton>
        </Box>
      </Box>
      <div>
        {assets ? (
          <>
            {hasAssets ? (
              <Carousel
                renderArrow={myArrow}
                showArrows={true}
                breakPoints={breakPoints}
              >
                {assets?.map((asset) => (
                  <>
                    {["image","image/jpeg", "image/png", "image/svg"].includes(asset?.meta_data?.file_type)  && (
                      <img
                        src={asset?.file_url} // --- pending
                        alt="asset"
                        height="500px"
                        width="100%"
                        style={{
                          objectFit:"contain",
                          borderRadius:"8px"
                        }}
                      />
                    )}
                    {(["application","application/pdf", "pdf"].includes(asset?.meta_data?.file_type))  && (
                        <div
                          style={{
                            height: "500px",
                            marginLeft: "10px",
                            width: "100%",
                          }}
                        >
                          <DocumentViewer url={asset?.file_url} />
                        </div>
                      )}
                      {asset?.meta_data?.file_type === "mp4" &&
                      (asset?.blob
                        ? <VideoCard
                          controls={true}
                          style={{
                            height: "350px",
                            width: "100%",
                            borderRadius: "4px",
                            objectFit: "contain"
                          }}
                          videoBlob={asset?.blob} />
                        : <video
                          style={{
                            height: "350px",
                            width: "100%",
                            borderRadius: "4px",
                            objectFit: "contain"
                          }}
                          controls
                          playsInline>
                        <source src={asset?.file_url + "#t=0.001"} type="video/mp4" />
                        </video>)
                    }
                    {asset?.meta_data?.file_type === "mpeg" &&
                      <Box p={"24px 0px"} width={"100%"} alignItems={"center"} display={"flex"}
                      style={{
                        height: "350px",
                        width: "100%",
                        borderRadius: "4px",
                      }}>
                        {asset?.file_url &&
                          <audio controls style={{ width: "inherit" }}>
                            <source src={asset?.file_url} type="audio/mpeg" />
                          </audio>}
                      </Box>
                    }
                  </>
                ))}
              </Carousel>
            ) : (
              <>
                {data?.type === "pdf" ? (
                  <>
                    <div
                      style={{
                        height: "500px",
                        marginLeft: "10px",
                        width: "100%",
                      }}
                    >
                      <DocumentViewer url={data?.file_url} />
                    </div>
                  </>
                ) : (
                  <img
                    src={generateImageUrl(data?.file_url,img_size.medium_rectangle)}
                    alt=""
                    height="500px"
                    width="100%"
                    style={{
                      objectFit:"contain",
                      borderRadius:"8px"
                    }}
                  />
                )}
              </>
            )}
          </>
        ) : (
          <NoDataFound
            height={210}
            content="No Assets Found!"
          />
        )}
      </div>
    </>
  );
};

export default ImageAndPdfViewer;
